<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--left-center" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="M9.35 5.496 6.333 8.513 9.35 11.53" stroke="currentColor"/></svg>
</template>